<sc-flex centered>

  <ng-container *ngFor="let structure of structures, let i = index">
    <sc-content-spacer *ngIf="i>0"></sc-content-spacer>
    <app-sac-header-tab [structure]="structure" [selected]="currentStructure === structure"
      (close)="closeStructure($event)" (select)="selectStructure($event)"></app-sac-header-tab>
  </ng-container>

  <sc-content-spacer double></sc-content-spacer>

  <sc-action-icon iconClass="fa-plus" (click)="addStructure()"></sc-action-icon>

  <sc-content-spacer grow></sc-content-spacer>

  <sc-action-icon mat-icon-button [matMenuTriggerFor]="appMenu" iconClass="fa-cog">
  </sc-action-icon>

  <sc-content-spacer *ngIf="sacClientContext.standaloneMode"></sc-content-spacer>
  <ac-language-selection-field *ngIf="sacClientContext.standaloneMode"></ac-language-selection-field>

  <sc-content-spacer *ngIf="showOptionConnectionDialog"></sc-content-spacer>
  <sc-icon iconClass="fa-qrcode" (click)="showTransportOptionsGcConnectionDialog()" *ngIf="showOptionConnectionDialog">
  </sc-icon>

</sc-flex>
<sc-content-spacer vertical></sc-content-spacer>

<mat-menu #appMenu="matMenu" class="sac-option-menu" [formGroup]="settingsFormGroup">
  <div mat-menu-item (click)="$event.stopPropagation();">
    <mat-checkbox name="highlightNewTransports" formControlName="highlightNewTransports">
      <sc-dictionary-label
        dictionaryKey="tmc-yard.ui.control.sac-client.sac-header.option.highlight-available-transports"></sc-dictionary-label>
    </mat-checkbox>
  </div>
  <div mat-menu-item (click)="$event.stopPropagation();">
    <mat-checkbox name="notificationsEnabled" formControlName="notificationsEnabled">
      <sc-dictionary-label
        dictionaryKey="tmc-yard.ui.control.sac-client.sac-header.option.play-notification-sound"></sc-dictionary-label>
    </mat-checkbox>
  </div>
  <sc-content-spacer vertical half></sc-content-spacer>
  <mat-divider></mat-divider>
  <sc-content-spacer vertical half></sc-content-spacer>
  <div mat-menu-item (click)="switchMode('complex')">
    <sc-flex>
      <sc-content-spacer half></sc-content-spacer>
      <sc-icon iconClass="fa-desktop"></sc-icon>
      <sc-content-spacer half></sc-content-spacer>
      <sc-dictionary-label dictionaryKey="Desktop"></sc-dictionary-label>
    </sc-flex>
  </div>
  <div mat-menu-item (click)="switchMode('assign')">
    <sc-flex>
      <sc-content-spacer half></sc-content-spacer>
      <sc-icon iconClass="fa-truck-container"></sc-icon>
      <sc-content-spacer half></sc-content-spacer>
      <sc-dictionary-label dictionaryKey="Truck Control"></sc-dictionary-label>
    </sc-flex>
  </div>
  <div mat-menu-item (click)="switchMode('control')">
    <sc-flex>
      <sc-content-spacer half></sc-content-spacer>
      <sc-icon iconClass="fa-forklift"></sc-icon>
      <sc-content-spacer half></sc-content-spacer>
      <sc-dictionary-label dictionaryKey="Forklift"></sc-dictionary-label>
    </sc-flex>
  </div>
</mat-menu>
